import {
  setAnonCreatorMode,
  updateAnonymousUsername,
} from 'actions/shareVideo';
import {
  HIDE_FOLDER_HIERARCHY,
  RESET_TRANSCRIPT_STATE,
  SHARE_VIDEO_MOVE_SUCCESS,
  SHOW_FOLDER_HIERARCHY,
  TOGGLE_IS_TRANSCRIPT_SEARCH_OPEN,
  UPDATE_CURRENT_SEARCH_INDEX,
  UPDATE_CURRENT_USER_IS_OWNER,
  UPDATE_SHARE_VIDEO,
  UPDATE_SHARE_VIDEO_DOWNLOAD_URL,
  UPDATE_SHARE_VIDEO_IFRAME_LOADED,
  UPDATE_SHARE_VIDEO_IN_TRIM_MODE,
  UPDATE_SHARE_VIDEO_NAME,
  UPDATE_SHARE_VIDEO_PASSWORD,
  UPDATE_SHARE_VIDEO_PLAYER_READY,
  UPDATE_SHARE_VIDEO_SHOW_REMOVE_MODAL,
  UPDATE_TRANSCRIPT_DETAILS,
  UPDATE_TRANSCRIPT_PANEL_MODE,
  UPDATE_TRANSCRIPT_SEARCH_INPUT_VALUE,
  UPDATE_TRANSCRIPT_SEARCH_PHRASE,
  UPDATE_TRANSCRIPT_SEARCH_PHRASE_INDEX_ARRAY,
  UPDATE_TRANSCRIPT_STATUS,
  UPDATE_TRANSCRIPT_VERSION,
  UPDATE_USER_HAS_OPENED_TRANSCRIPT,
  UPDATE_VIDEO_CTA,
  UPDATE_VIDEO_CTA_ENABLED,
  UPDATE_VIDEO_CTA_MODAL_SHOW,
  UPDATE_VIDEO_CTA_MODS,
  UPDATE_VIDEO_CTA_SHOW,
  UPDATE_VIDEO_CTA_TEXT,
  UPDATE_VIDEO_CTA_URL,
  UPDATE_VIDEO_DESCRIPTION,
  UPDATE_VIDEO_IFRAME_VISIBLITY,
  UPDATE_VIDEO_SHARE_ALIAS,
  UPDATE_VIDEO_SHARE_SFDC_MODAL_SHOW,
  USER_HAS_UPDATED_BUTTON_TEXT,
} from 'constants/actions';
import { IN_PROGRESS } from 'constants/videoTranscript';

const DEFAULT_TRANSCRIPT_SEARCH_STATE = {
  isTranscriptSearchOpen: false,
  transcriptSearchPhrase: '',
  transcriptSearchInputValue: '',
  transcriptSearchPhraseIndexArray: [],
  currentSearchIndex: 0,
};

export const TRANSCRIPT_PANEL_MODE_VIEW = 'view';
export const TRANSCRIPT_PANEL_MODE_CORRECTION = 'correction';

const DEFAULT_STATE = {
  cta_enabled: false,
  cta_show: false,
  cta_text: null,
  cta_url: null,
  cta_modal_show: false,
  cta_mods: null,

  iframe_loaded: false,
  iframe_visible: false,
  player_ready: false,
  video: null,
  video_folders: [],
  shareVideoAliases: [],
  sfdcModalShow: false,

  download_url: null,
  url_for_display: null, // URL to show next to 'Add link to page you recorded on?'
  current_user_is_owner: false,
  currentUserCanEdit: false,
  user_updated_button_text: false,
  video_name: '',
  password: null,
  video_is_team_shared: false, // only true if video is in the team workspace AND the user belongs to the same team

  in_trim_mode: false,
  show_folder_hierarchy: false,
  show_remove_modal: false,

  settings_modal_err: null,
  transcript: null,
  transcript_details: {},
  userHasOpenedTranscript: false,
  transcriptPanelMode: TRANSCRIPT_PANEL_MODE_VIEW,
  transcriptSearch: {
    ...DEFAULT_TRANSCRIPT_SEARCH_STATE,
  },
  isTranscriptCorrectionPopUpOpen: false,
  transcriptSelectedOccurrenceIndex: -1,
  anonCreatorMode: false,
};

const shareVideoReducer = (state = DEFAULT_STATE, action) => {
  let newState = state;

  switch (action.type) {
    case SHARE_VIDEO_MOVE_SUCCESS:
      newState = {
        ...state,
        video_folders: action.folders,
      };
      break;
    case SHOW_FOLDER_HIERARCHY:
      newState = { ...state, show_folder_hierarchy: true };
      break;
    case HIDE_FOLDER_HIERARCHY:
      newState = { ...state, show_folder_hierarchy: false };
      break;
    case UPDATE_CURRENT_USER_IS_OWNER:
      newState = { ...state, current_user_is_owner: action.currentUserIsOwner };
      break;
    case UPDATE_SHARE_VIDEO_DOWNLOAD_URL:
      newState = {
        ...state,
        download_url: action.downloadUrl,
      };
      break;
    case UPDATE_SHARE_VIDEO_IFRAME_LOADED:
      newState = { ...state, iframe_loaded: action.loaded };
      break;
    case UPDATE_SHARE_VIDEO_IN_TRIM_MODE:
      newState = { ...state, in_trim_mode: action.inTrimMode };
      break;
    case UPDATE_SHARE_VIDEO_PASSWORD:
      newState = {
        ...state,
        password: action.password,
      };
      break;
    case UPDATE_SHARE_VIDEO_PLAYER_READY:
      newState = {
        ...state,
        player_ready: action.playerReady,
      };
      break;
    case UPDATE_SHARE_VIDEO:
      newState = {
        ...state,
        current_user_is_owner:
          action.video && action.video.current_user_is_owner,
        currentUserCanEdit: action.video && action.video.currentUserCanEdit,
        url_for_display:
          (action.video && action.video.video_properties.from_url) || null,
        video_folders:
          (action.video != null && action.video.folders) ||
          state.video_folders ||
          DEFAULT_STATE.video_folders,
        video_name: (action.video || { name: '' }).name,
        video: action.video,
        cta_enabled: action.video.cta?.enabled,
        cta_text: action.video.cta.text,
        cta_url: action.video.cta.url,
        cta_mods: action.video.cta.mods,
        video_is_team_shared: action.video.is_team_shared,
        visibility: action.video.visibility,
      };
      break;
    case UPDATE_SHARE_VIDEO_NAME:
      newState = {
        ...state,
        video_name: action.name,
        video: { ...state.video, name: action.name },
      };
      break;
    case UPDATE_VIDEO_DESCRIPTION:
      newState = {
        ...state,
        video: {
          ...state.video,
          description: action.description,
        },
      };
      break;
    case UPDATE_SHARE_VIDEO_SHOW_REMOVE_MODAL:
      newState = {
        ...state,
        show_remove_modal: action.show,
      };
      break;
    case UPDATE_VIDEO_IFRAME_VISIBLITY:
      newState = {
        ...state,
        iframe_visible: true,
      };
      break;
    case UPDATE_VIDEO_CTA:
      newState = {
        ...state,
        cta_enabled: action.cta.enabled,
        cta_text: action.cta.text,
        cta_url: action.cta.url,
        cta_mods: action.cta.mods,
      };
      break;
    case UPDATE_VIDEO_CTA_ENABLED:
      newState = { ...state, cta_enabled: action.ctaEnabled };
      break;
    case UPDATE_VIDEO_CTA_SHOW:
      newState = { ...state, cta_show: action.ctaShow };
      break;
    case UPDATE_VIDEO_CTA_TEXT:
      newState = { ...state, cta_text: action.ctaText };
      break;
    case UPDATE_VIDEO_CTA_URL:
      newState = { ...state, cta_url: action.ctaUrl };
      break;
    case UPDATE_VIDEO_CTA_MODAL_SHOW:
      newState = { ...state, cta_modal_show: action.showModal };
      break;
    case UPDATE_VIDEO_CTA_MODS:
      newState = { ...state, cta_mods: action.mods };
      break;
    case UPDATE_VIDEO_SHARE_SFDC_MODAL_SHOW:
      newState = { ...state, sfdcModalShow: action.sfdcModalShow };
      break;
    case UPDATE_VIDEO_SHARE_ALIAS:
      newState = { ...state, shareVideoAliases: action.shareVideoAliases };
      break;
    case UPDATE_TRANSCRIPT_DETAILS:
      newState = { ...state, transcript_details: action.transcriptDetails };
      break;
    case UPDATE_TRANSCRIPT_VERSION:
      newState = {
        ...state,
        transcript_details: {
          ...state.transcript_details,
          version: action.version,
        },
      };
      break;
    case UPDATE_TRANSCRIPT_STATUS:
      newState = {
        ...state,
        transcript_details: {
          ...state.transcript_details,
          transcription_status: action.status,
        },
      };
      break;
    case UPDATE_USER_HAS_OPENED_TRANSCRIPT:
      newState = { ...state, userHasOpenedTranscript: true };
      break;
    case USER_HAS_UPDATED_BUTTON_TEXT:
      newState = {
        ...state,
        user_updated_button_text: action.button_text_updated,
      };
      break;
    case RESET_TRANSCRIPT_STATE:
      newState = {
        ...state,
        transcript: null,
        transcript_details: {
          ...state.transcript_details,
          transcription_status: IN_PROGRESS,
        },
      };
      break;
    case TOGGLE_IS_TRANSCRIPT_SEARCH_OPEN:
      newState = {
        ...state,
        transcriptSearch: {
          ...DEFAULT_TRANSCRIPT_SEARCH_STATE,
          isTranscriptSearchOpen: action.isTranscriptSearchOpen,
        },
      };
      break;
    case UPDATE_TRANSCRIPT_SEARCH_PHRASE:
      newState = {
        ...state,
        transcriptSearch: {
          ...state.transcriptSearch,
          transcriptSearchPhrase: action.transcriptSearchPhrase,
        },
      };
      break;
    case UPDATE_TRANSCRIPT_SEARCH_INPUT_VALUE:
      newState = {
        ...state,
        transcriptSearch: {
          ...state.transcriptSearch,
          transcriptSearchInputValue: action.transcriptSearchInputValue,
        },
      };
      break;
    case UPDATE_TRANSCRIPT_SEARCH_PHRASE_INDEX_ARRAY:
      newState = {
        ...state,
        transcriptSearch: {
          ...state.transcriptSearch,
          transcriptSearchPhraseIndexArray:
            action.transcriptSearchPhraseIndexArray,
        },
      };
      break;
    case UPDATE_CURRENT_SEARCH_INDEX:
      newState = {
        ...state,
        transcriptSearch: {
          ...state.transcriptSearch,
          currentSearchIndex: action.currentSearchIndex,
        },
      };
      break;
    case updateAnonymousUsername.toString():
      newState = {
        ...state,
        anonymousUsername: action.payload,
      };
      break;
    case UPDATE_TRANSCRIPT_PANEL_MODE:
      newState = {
        ...state,
        transcriptPanelMode: action.transcriptPanelMode,
      };
      break;
    case setAnonCreatorMode.toString():
      newState = {
        ...state,
        anonCreatorMode: action.payload,
      };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default shareVideoReducer;
